module.exports = __webpack_public_path__ + "img/place.345f627.png";